(function () {
  var PRODUCTS = {
    carrier: {
      key: "carrier",
      title: "The Trendi Carrier",
      variantId: 45403572895813,
      variantIds: [45403572830277, 45403572863045, 45403572895813],
      url: "/products/the-trendi-carrier",
      fallbackPrice: 15247
    },
    wrap: {
      key: "wrap",
      title: "The Original Wrap",
      variantId: 45110359851077,
      variantIds: [45110359851077, 45403573452869, 45403573485637, 45403573518405],
      url: "/products/the-original-wrap",
      fallbackPrice: 4999
    },
    pack: {
      key: "pack",
      title: "Pack Newborn",
      variantId: 45403560280133,
      variantIds: [45403560280133],
      url: "/products/pack-newborn",
      fallbackPrice: 16086
    }
  };

  var LIVE_PRODUCTS = window.BABIINI_SHOPIFY_PRODUCTS || {};
  Object.keys(PRODUCTS).forEach(function (key) {
    var liveProduct = LIVE_PRODUCTS[key];
    if (!liveProduct) return;
    var liveVariantIds = Object.keys(liveProduct.variants || {}).filter(function (label) { return String(label).toLocaleLowerCase("es") !== "fancy cow"; }).map(function (label) {
      return Number(liveProduct.variants[label]);
    }).filter(Boolean);
    var defaultVariantId = Number(liveProduct.defaultVariantId);
    var defaultVariantLabel = Object.keys(liveProduct.variants || {}).find(function (label) { return Number(liveProduct.variants[label]) === defaultVariantId; });
    if (String(defaultVariantLabel || "").toLocaleLowerCase("es") === "fancy cow") defaultVariantId = Number(liveProduct.variants.Houndstooth || 0);
    if (defaultVariantId && liveVariantIds.indexOf(defaultVariantId) === -1) {
      liveVariantIds.unshift(defaultVariantId);
    }
    if (defaultVariantId) PRODUCTS[key].variantId = defaultVariantId;
    if (liveVariantIds.length) PRODUCTS[key].variantIds = liveVariantIds;
  });

  var VARIANT_IMAGES = {
    "45403572830277": "home/carrier-clay.webp",
    "45403572863045": "home/carrier-blue.webp",
    "45403572895813": "meta-ads/products/carrier-houndstooth-figma.webp",
    "45110359851077": "home/wrap-lime.webp",
    "45403573452869": "home/wrap-charcoal.webp",
    "45403573485637": "home/wrap-gray.webp",
    "45403573518405": "home/wrap-white.webp",
    "45403560280133": "home/promo-newborn-mobile.webp"
  };

  var INSTAGRAM_URL = "https://www.instagram.com/babiini.es/";
  var menuButton = document.querySelector("[data-menu-toggle]");
  var menuCloseButton = document.querySelector("[data-menu-close]");
  var menuPanel = document.querySelector("[data-menu]");
  var cartOverlay = document.querySelector("[data-cart-overlay]");
  var cartEmptyPanel = document.querySelector("[data-cart-empty]");
  var cartFilledPanel = document.querySelector("[data-cart-filled]");
  var mobileQuery = window.matchMedia("(max-width: 767px)");
  var reducedMotionQuery = window.matchMedia("(prefers-reduced-motion: reduce)");
  var MENU_TRANSITION_MS = 320;
  var previousBodyOverflow = "";
  var menuOpen = false;
  var menuClosing = false;
  var menuCloseTimer = 0;
  var cartOpen = false;
  var cartState = null;
  var cartPresentation = {};

  function qsAll(selector, root) {
    return Array.prototype.slice.call((root || document).querySelectorAll(selector));
  }

  function isInteractive(target) {
    return Boolean(target.closest("a, button, input, select, textarea, label"));
  }

  function refreshCartNodes() {
    cartOverlay = document.querySelector("[data-cart-overlay]");
    cartEmptyPanel = document.querySelector("[data-cart-empty]");
    cartFilledPanel = document.querySelector("[data-cart-filled]");
  }

  function setBodyLock() {
    var shouldLock = menuOpen || menuClosing || cartOpen;
    if (shouldLock && document.body.style.overflow !== "hidden") {
      previousBodyOverflow = document.body.style.overflow;
      document.body.style.overflow = "hidden";
    }
    if (!shouldLock && document.body.style.overflow === "hidden") {
      document.body.style.overflow = previousBodyOverflow;
    }
  }

  function finishMenuClose() {
    if (!menuPanel || menuOpen) return;
    window.clearTimeout(menuCloseTimer);
    menuCloseTimer = 0;
    menuClosing = false;
    menuPanel.classList.remove("is-closing");
    menuPanel.hidden = true;
    setBodyLock();
  }

  function openMenu() {
    if (!menuPanel) return;
    window.clearTimeout(menuCloseTimer);
    menuCloseTimer = 0;
    menuClosing = false;
    menuPanel.hidden = false;
    menuPanel.classList.remove("is-closing");
    menuPanel.setAttribute("aria-hidden", "false");
    menuOpen = true;
    menuButton && menuButton.setAttribute("aria-expanded", "true");
    menuButton && menuButton.setAttribute("aria-label", "Close menu");
    var pageShell = menuButton && menuButton.closest(".shop-page, .pg-page, .tutorial-page, .tc-page, .meta-page, .reviews-page, main");
    pageShell && pageShell.classList.add("menu-open");
    setBodyLock();

    if (reducedMotionQuery.matches) {
      menuPanel.classList.add("is-open");
      return;
    }

    window.requestAnimationFrame(function () {
      if (menuOpen) menuPanel.classList.add("is-open");
    });
  }

  function closeMenu() {
    if (!menuPanel || menuPanel.hidden || menuClosing) return;
    menuOpen = false;
    menuClosing = true;
    menuPanel.classList.remove("is-open");
    menuPanel.classList.add("is-closing");
    menuPanel.setAttribute("aria-hidden", "true");
    menuButton && menuButton.setAttribute("aria-expanded", "false");
    menuButton && menuButton.setAttribute("aria-label", "Open menu");
    var pageShell = menuButton && menuButton.closest(".shop-page, .pg-page, .tutorial-page, .tc-page, .meta-page, .reviews-page, main");
    pageShell && pageShell.classList.remove("menu-open");
    setBodyLock();

    if (reducedMotionQuery.matches) {
      finishMenuClose();
      return;
    }

    menuCloseTimer = window.setTimeout(finishMenuClose, MENU_TRANSITION_MS);
  }

  function toggleMenu() {
    if (!menuPanel || menuPanel.hidden) openMenu();
    else closeMenu();
  }

  function formatMoney(cents) {
    var value = Number(cents || 0) / 100;
    return "€" + value.toFixed(2).replace(".", ",");
  }

  function productForVariant(variantId) {
    var numericId = Number(variantId);
    return Object.keys(PRODUCTS).map(function (key) {
      return PRODUCTS[key];
    }).find(function (product) {
      return product.variantIds.indexOf(numericId) !== -1;
    });
  }

  function variantAssetForItem(item) {
    var variantTitle = String(item && item.variant_title || "").toLocaleLowerCase("es");
    var variantAssets = {
      "dessert brown": "home/carrier-clay.webp",
      "desert brown": "home/carrier-clay.webp",
      "maya blue": "home/carrier-blue.webp",
      "houndstooth": "meta-ads/products/carrier-houndstooth-figma.webp",
      "pistachio green": "home/wrap-lime.webp",
      "midnight black": "home/wrap-charcoal.webp",
      "pebble gray": "home/wrap-gray.webp",
      "white bubble": "home/wrap-white.webp"
    };
    var label = Object.keys(variantAssets).find(function (candidate) {
      return variantTitle.indexOf(candidate) !== -1;
    });
    return label && window.babiiniAssetUrl
      ? window.babiiniAssetUrl(variantAssets[label])
      : "";
  }

  function itemForProduct(cart, productKey) {
    if (!cart || !cart.items) return null;
    var product = PRODUCTS[productKey];
    if (!product) return null;
    return cart.items.find(function (item) {
      return product.variantIds.indexOf(Number(item.variant_id)) !== -1;
    }) || null;
  }

  function getLinePieces(productKey) {
    var pieces = [];

    qsAll('[data-cart-line-price="' + productKey + '"]').forEach(function (priceNode) {
      var pgLine = priceNode.closest(".pg-cart-line");
      if (pgLine) {
        pieces.push(pgLine);
        var next = pgLine.nextElementSibling;
        if (next && next.classList.contains("pg-cart-divider")) pieces.push(next);
      }

      var staticCopy = priceNode.closest(".cart-product-copy");
      if (staticCopy) {
        var suffix = staticCopy.classList.contains("cart-product-copy-first") ? "first" : "second";
        pieces = pieces.concat(qsAll(".cart-product-copy-" + suffix + ", .cart-product-image-" + suffix + ", .cart-quantity-" + suffix));
      }
    });

    return pieces.filter(function (node, index, arr) {
      return node && arr.indexOf(node) === index;
    });
  }

  function setLineVisibility(productKey, visible) {
    getLinePieces(productKey).forEach(function (node) {
      node.hidden = !visible;
      node.classList.toggle("is-cart-line-hidden", !visible);
    });
  }

  function createModernCartLine(item) {
    var article = document.createElement("article");
    article.className = "cart-line";
    article.dataset.shopifyCartLine = item.key;
    article.dataset.shopifyCartVariant = String(item.variant_id || "");

    var image = document.createElement("img");
    var product = productForVariant(item.variant_id);
    var presentation = cartPresentation[String(item.variant_id)] || {};
    var featuredImage = item.featured_image && item.featured_image.url;
    var variantImage = variantAssetForItem(item);
    var legacyVariantImage = VARIANT_IMAGES[String(item.variant_id)];
    var fallbackImage = legacyVariantImage
      ? window.babiiniAssetUrl && window.babiiniAssetUrl(legacyVariantImage)
      : product && product.key === "carrier"
      ? window.babiiniAssetUrl && window.babiiniAssetUrl("cart/trendi-fancy-cow.webp")
      : product && product.key === "wrap"
      ? window.babiiniAssetUrl && window.babiiniAssetUrl("cart/original-midnight-black.webp")
      : "";
    image.src = presentation.image || variantImage || featuredImage || item.image || fallbackImage || "";
    image.width = 88;
    image.height = 104;
    image.alt = item.variant_title && item.variant_title !== "Default Title"
      ? item.product_title + ", " + item.variant_title
      : item.product_title;

    var copy = document.createElement("div");
    copy.className = "cart-line__copy";
    var title = document.createElement("h3");
    title.textContent = item.product_title || item.title || "Producto Babiini";
    var variant = document.createElement("p");
    variant.textContent = presentation.color
      ? "Color: " + presentation.color
      : item.variant_title && item.variant_title !== "Default Title"
      ? "Color: " + item.variant_title
      : "Producto Babiini";
    var size = document.createElement("p");
    size.className = "cart-line__size";
    size.setAttribute("translate", "no");
    size.textContent = "Talla: Única";
    var price = document.createElement("strong");
    price.textContent = item.quantity + " x " + formatMoney(item.final_price);
    copy.append(title, variant, size, price);

    var controls = document.createElement("div");
    controls.className = "quantity";
    var decrease = document.createElement("button");
    decrease.type = "button";
    decrease.dataset.shopifyCartChange = "decrease";
    decrease.setAttribute("aria-label", "Quitar una unidad de " + title.textContent);
    decrease.textContent = "−";
    var count = document.createElement("span");
    count.textContent = String(item.quantity);
    var increase = document.createElement("button");
    increase.type = "button";
    increase.dataset.shopifyCartChange = "increase";
    increase.setAttribute("aria-label", "Agregar una unidad de " + title.textContent);
    increase.textContent = "+";
    controls.append(decrease, count, increase);

    article.append(image, copy, controls);
    return article;
  }

  function updateModernCartLine(line, item) {
    if (!line || !item) return;
    line.dataset.shopifyCartLine = item.key;
    line.dataset.shopifyCartVariant = String(item.variant_id || "");

    var price = line.querySelector(".cart-line__copy strong");
    var count = line.querySelector(".quantity span");
    if (price) price.textContent = item.quantity + " x " + formatMoney(item.final_price);
    if (count) count.textContent = String(item.quantity);
  }

  function renderModernCartLines(cart) {
    qsAll("[data-cart-lines]").forEach(function (container) {
      var items = cart.items || [];
      var existingLines = qsAll("[data-shopify-cart-line]", container);
      var canUpdateInPlace = existingLines.length === items.length && existingLines.every(function (line, index) {
        return line.dataset.shopifyCartLine === items[index].key
          || line.dataset.shopifyCartVariant === String(items[index].variant_id || "");
      });

      if (canUpdateInPlace) {
        items.forEach(function (item, index) {
          updateModernCartLine(existingLines[index], item);
        });
        return;
      }

      var lines = items.map(createModernCartLine);
      container.replaceChildren.apply(container, lines);
    });
  }

  function updateCartClasses(cart) {
    refreshCartNodes();
    var hasCarrier = Boolean(itemForProduct(cart, "carrier"));
    var hasWrap = Boolean(itemForProduct(cart, "wrap"));
    var hasPack = Boolean(itemForProduct(cart, "pack"));
    [cartFilledPanel].concat(qsAll(".cart-panel-filled, .pg-cart-panel-filled")).forEach(function (panel) {
      if (!panel) return;
      panel.classList.toggle("cart-single-carrier", hasCarrier && !hasWrap);
      panel.classList.toggle("cart-single-wrap", hasWrap && !hasCarrier);
      panel.classList.toggle("cart-has-both", hasCarrier && hasWrap);
      panel.classList.toggle("cart-is-empty", !hasCarrier && !hasWrap && !hasPack);
    });
  }

  function ensureCartCountBadges() {
    qsAll("[data-cart-open]").forEach(function (opener) {
      if (opener.querySelector("[data-cart-count]")) return;
      var count = document.createElement("span");
      count.className = "navbar__cart-count";
      count.setAttribute("data-cart-count", "");
      count.setAttribute("aria-label", "0 productos en el carrito");
      count.hidden = true;
      opener.appendChild(count);
    });
  }

  function updateCartUI(cart) {
    refreshCartNodes();
    cartState = cart || { item_count: 0, items: [], total_price: 0 };
    var hasItems = cartState.item_count > 0;
    ensureCartCountBadges();
    qsAll("[data-cart-count]").forEach(function (node) {
      node.textContent = String(cartState.item_count || 0);
      node.setAttribute("aria-label", cartState.item_count + (cartState.item_count === 1 ? " producto en el carrito" : " productos en el carrito"));
      node.hidden = !hasItems;
    });

    if (cartEmptyPanel) cartEmptyPanel.hidden = hasItems;
    if (cartFilledPanel) cartFilledPanel.hidden = !hasItems;
    qsAll("[data-cart-empty]").forEach(function (panel) {
      panel.setAttribute("aria-hidden", String(hasItems));
    });
    qsAll("[data-cart-filled]").forEach(function (panel) {
      panel.setAttribute("aria-hidden", String(!hasItems));
    });

    renderModernCartLines(cartState);

    Object.keys(PRODUCTS).forEach(function (key) {
      var product = PRODUCTS[key];
      var item = itemForProduct(cartState, key);
      var quantity = item ? item.quantity : 0;
      var price = item ? item.final_price : product.fallbackPrice;

      qsAll('[data-cart-qty="' + key + '"]').forEach(function (node) {
        node.textContent = String(quantity);
      });
      qsAll('[data-cart-line-price="' + key + '"]').forEach(function (node) {
        node.textContent = quantity + " x " + formatMoney(price);
      });
      setLineVisibility(key, Boolean(item));
    });

    var total = formatMoney(cartState.total_price || 0);
    qsAll("[data-cart-total], [data-cart-total-desktop], [data-cart-total-mobile]").forEach(function (node) {
      node.textContent = total;
    });

    updateCartClasses(cartState);
  }

  async function getCart() {
    try {
      var response = await fetch("/cart.js", {
        headers: { "Accept": "application/json" },
        credentials: "same-origin"
      });
      if (!response.ok) throw new Error("Cart fetch failed");
      var cart = await response.json();
      updateCartUI(cart);
      return cart;
    } catch (error) {
      console.warn("[Babiini] Could not load cart", error);
      return cartState || { item_count: 0, items: [], total_price: 0 };
    }
  }

  async function addItems(items) {
    var response = await fetch("/cart/add.js", {
      method: "POST",
      headers: {
        "Accept": "application/json",
        "Content-Type": "application/json"
      },
      credentials: "same-origin",
      body: JSON.stringify({ items: items })
    });
    if (!response.ok) {
      var detail = await response.text();
      throw new Error(detail || "Cart add failed");
    }
    return getCart();
  }

  async function changeQuantity(productKey, nextQuantity) {
    var product = PRODUCTS[productKey];
    if (!product) return;

    var response = await fetch("/cart/change.js", {
      method: "POST",
      headers: {
        "Accept": "application/json",
        "Content-Type": "application/json"
      },
      credentials: "same-origin",
      body: JSON.stringify({
        id: String(product.variantId),
        quantity: Math.max(0, nextQuantity)
      })
    });
    if (!response.ok) throw new Error("Cart quantity update failed");
    var cart = await response.json();
    updateCartUI(cart);
  }

  async function changeLineQuantity(lineKey, nextQuantity) {
    var response = await fetch("/cart/change.js", {
      method: "POST",
      headers: {
        "Accept": "application/json",
        "Content-Type": "application/json"
      },
      credentials: "same-origin",
      body: JSON.stringify({
        id: String(lineKey),
        quantity: Math.max(0, nextQuantity)
      })
    });
    if (!response.ok) throw new Error("Cart quantity update failed");
    var cart = await response.json();
    updateCartUI(cart);
  }

  function openCart() {
    refreshCartNodes();
    if (!cartOverlay) {
      window.location.href = "/cart";
      return;
    }
    closeMenu();
    getCart();
    cartOverlay.hidden = false;
    cartOpen = true;
    setBodyLock();
  }

  function closeCart() {
    refreshCartNodes();
    if (!cartOverlay) return;
    cartOverlay.hidden = true;
    cartOpen = false;
    setBodyLock();
  }

  function goShop() {
    closeMenu();
    closeCart();
    if (window.location.pathname === "/" || window.location.pathname === "") {
      var products = document.getElementById("products");
      if (products) {
        products.scrollIntoView({ behavior: reducedMotionQuery.matches ? "auto" : "smooth", block: "start" });
        return;
      }
    }
    window.location.href = "/pages/comprar";
  }

  function closestText(element) {
    var source = element.closest(".shop-product-card, .tc-related-card, .product-card, .meta-product-card, .pg-product-type-card, .promo-card, .monthly-offer, .tc-product, main");
    return (source || element).textContent.toLowerCase();
  }

  function inferCartAdd(element) {
    var explicit = element.getAttribute("data-cart-add") || element.getAttribute("data-product");
    if (explicit === "carrier" || explicit === "wrap" || explicit === "pack") return explicit;
    var productName = String(element.getAttribute("data-cart-name") || "").toLowerCase();
    if (/original|wrap|fular/.test(productName)) return "wrap";
    if (/trendi|carrier|mochila/.test(productName)) return "carrier";
    var explicitKey = String(explicit || "").toLowerCase();
    if (/original|wrap/.test(explicitKey)) return "wrap";
    if (/trendi|carrier/.test(explicitKey)) return "carrier";

    var buttonText = element.textContent.trim().toLowerCase();
    if (/agregar otro producto|comprar ya|comparar productos|comprar productos/.test(buttonText)) return null;

    if (element.closest(".promo-card")) {
      var promoCards = qsAll(".promo-card");
      return promoCards.indexOf(element.closest(".promo-card")) === 0 ? "pack" : "wrap";
    }
    if (element.closest(".monthly-offer")) return "carrier";
    if (element.closest("#wraps")) return "wrap";
    if (element.closest("#carriers")) return "carrier";

    var path = window.location.pathname;
    if (path.indexOf("the-original-wrap") !== -1) return "wrap";
    if (path.indexOf("the-trendi-carrier") !== -1) return "carrier";

    var text = closestText(element);
    if (/original|wrap|fular/.test(text)) return "wrap";
    if (/trendi|carrier|mochila/.test(text)) return "carrier";

    return null;
  }

  function cartItemsForKey(key, quantity) {
    if (key === "pack") {
      return [
        { id: PRODUCTS.carrier.variantId, quantity: quantity },
        { id: PRODUCTS.wrap.variantId, quantity: quantity }
      ];
    }
    if (!PRODUCTS[key]) return [];
    return [{ id: PRODUCTS[key].variantId, quantity: quantity }];
  }

  async function handleCartAdd(event) {
    var button = event.currentTarget;
    var key = inferCartAdd(button);
    if (!key) {
      if (button.tagName === "A" && button.getAttribute("href")) return;
      goShop();
      return;
    }

    event.preventDefault();
    var quantityInput = button.closest(".tc-form-card, [data-tc-form]")?.querySelector(".tc-quantity-input");
    var quantity = quantityInput ? Math.max(1, Number(quantityInput.value) || 1) : 1;
    var items = cartItemsForKey(key, quantity);
    if (!items.length) return;

    items.forEach(function (item) {
      cartPresentation[String(item.id)] = {
        color: button.getAttribute("data-cart-color") || "",
        image: button.getAttribute("data-cart-image") || ""
      };
    });

    button.disabled = true;
    button.setAttribute("aria-busy", "true");
    var previousText = button.textContent;
    button.classList.add("is-cart-loading");

    try {
      await addItems(items);
      openCart();
    } catch (error) {
      console.warn("[Babiini] Could not add item to cart", error);
      button.textContent = "Intenta de nuevo";
      setTimeout(function () {
        button.textContent = previousText;
      }, 1800);
    } finally {
      button.disabled = false;
      button.removeAttribute("aria-busy");
      button.classList.remove("is-cart-loading");
    }
  }

  function bindMenuAndCart() {
    menuButton && menuButton.addEventListener("click", toggleMenu);
    menuCloseButton && menuCloseButton.addEventListener("click", closeMenu);
    qsAll("[data-menu-link]").forEach(function (link) {
      link.addEventListener("click", closeMenu);
    });
    qsAll("[data-menu-shop], [data-cart-shop]").forEach(function (button) {
      button.addEventListener("click", function (event) {
        event.preventDefault();
        goShop();
      });
    });
    document.addEventListener("click", function (event) {
      var cartTrigger = event.target.closest("[data-cart-open]");
      if (!cartTrigger) return;
      event.preventDefault();
      openCart();
    });
    qsAll("[data-cart-add]").forEach(function (button) {
      button.addEventListener("click", handleCartAdd);
    });
    qsAll("[data-cart-close]").forEach(function (button) {
      button.addEventListener("click", closeCart);
    });
    qsAll(".cart-pay-button, .pg-cart-pay").forEach(function (button) {
      button.addEventListener("click", function () {
        window.location.href = "/checkout";
      });
    });
    cartOverlay && cartOverlay.addEventListener("mousedown", function (event) {
      if (event.target === cartOverlay) closeCart();
    });
    document.addEventListener("keydown", function (event) {
      if (event.key === "Escape") {
        closeMenu();
        closeCart();
      }
    });
  }

  function bindCartQuantities() {
    qsAll("[data-cart-increase], [data-cart-decrease]").forEach(function (button) {
      button.addEventListener("click", async function () {
        var key = button.getAttribute("data-cart-increase") || button.getAttribute("data-cart-decrease");
        var item = itemForProduct(cartState, key);
        if (!item) return;
        var delta = button.hasAttribute("data-cart-increase") ? 1 : -1;
        button.disabled = true;
        try {
          await changeQuantity(key, item.quantity + delta);
        } catch (error) {
          console.warn("[Babiini] Could not update quantity", error);
        } finally {
          button.disabled = false;
        }
      });
    });

    cartOverlay && cartOverlay.addEventListener("click", async function (event) {
      var button = event.target.closest("[data-shopify-cart-change]");
      if (!button) return;
      var line = button.closest("[data-shopify-cart-line]");
      var item = line && cartState && cartState.items.find(function (candidate) {
        return candidate.key === line.dataset.shopifyCartLine;
      });
      if (!item) return;

      if (line.dataset.cartUpdating === "true") return;
      var delta = button.dataset.shopifyCartChange === "increase" ? 1 : -1;
      line.dataset.cartUpdating = "true";
      line.setAttribute("aria-busy", "true");
      try {
        await changeLineQuantity(item.key, item.quantity + delta);
      } catch (error) {
        console.warn("[Babiini] Could not update cart line", error);
      } finally {
        delete line.dataset.cartUpdating;
        line.removeAttribute("aria-busy");
      }
    });
  }

  function inferProductUrl(card) {
    var explicitUrl = card.getAttribute("data-product-url");
    if (explicitUrl) return explicitUrl;
    var directLink = card.querySelector('a[href*="/products/"]');
    if (directLink) return directLink.getAttribute("href");
    var text = card.textContent.toLowerCase();
    if (/original|wrap|fular/.test(text)) return PRODUCTS.wrap.url;
    if (/trendi|carrier|mochila/.test(text)) return PRODUCTS.carrier.url;
    return null;
  }

  function bindProductCards() {
    qsAll(".product-card, .meta-product-card, .shop-card, .shop-product-card, .tc-related-card, .pg-product-type-card").forEach(function (card) {
      card.setAttribute("tabindex", card.getAttribute("tabindex") || "0");
      card.setAttribute("role", card.getAttribute("role") || "link");
      card.addEventListener("click", function (event) {
        if (isInteractive(event.target)) return;
        var url = inferProductUrl(card);
        if (url) window.location.href = url;
      });
      card.addEventListener("keydown", function (event) {
        if (event.key !== "Enter" && event.key !== " ") return;
        var url = inferProductUrl(card);
        if (!url) return;
        event.preventDefault();
        window.location.href = url;
      });
    });
  }

  function setupSlider(root, itemSelector, controlSelector) {
    if (!root) return;
    var items = qsAll(itemSelector, root);
    var controls = qsAll(controlSelector, root);
    if (items.length < 2 || controls.length < 2) return;

    root.classList.add("is-product-slider-ready");

    var index = 0;
    function update(nextIndex) {
      index = (nextIndex + items.length) % items.length;
      var compact = mobileQuery.matches;
      items.forEach(function (item, itemIndex) {
        item.classList.toggle("is-active", itemIndex === index);
        item.setAttribute("aria-hidden", compact && itemIndex !== index ? "true" : "false");
      });
    }

    controls.forEach(function (control, controlIndex) {
      control.setAttribute("role", "button");
      control.setAttribute("tabindex", "0");
      control.setAttribute("aria-label", controlIndex === 0 ? "Producto anterior" : "Producto siguiente");
      control.addEventListener("click", function () {
        update(index + (controlIndex === 0 ? -1 : 1));
      });
      control.addEventListener("keydown", function (event) {
        if (event.key !== "Enter" && event.key !== " ") return;
        event.preventDefault();
        update(index + (controlIndex === 0 ? -1 : 1));
      });
    });

    update(0);
    mobileQuery.addEventListener("change", function () {
      update(index);
    });
  }

  function bindProductSliders() {
    qsAll(".product-showcase").forEach(function (section) {
      setupSlider(section, ".product-card", ".product-slider-button");
    });
    qsAll(".tc-related").forEach(function (section) {
      setupSlider(section, ".tc-related-card", ".tc-slider-buttons span");
    });
  }

  function bindProductAccordions() {
    qsAll(".tc-tabs").forEach(function (tabs) {
      var blocks = qsAll(".tc-detail-block", tabs);
      var tabButtons = qsAll(".tc-tabs-menu button", tabs);
      if (!blocks.length) return;

      function panelNameForButton(button, index) {
        return button.getAttribute("data-tc-tab") || ["details", "shipping", "returns"][index] || "details";
      }

      function panelNameForBlock(block) {
        return block.getAttribute("data-tc-panel") || "details";
      }

      function setBlockOpen(block, isOpen) {
        var header = block.querySelector("header");
        var icon = block.querySelector("header span");
        block.classList.toggle("tc-detail-open", isOpen);
        if (header) header.setAttribute("aria-expanded", isOpen ? "true" : "false");
        if (icon) icon.textContent = isOpen ? "⊖" : "⊕";
      }

      function visibleBlocks() {
        return blocks.filter(function (block) {
          return !block.hidden;
        });
      }

      function setActivePanel(panelName) {
        tabButtons.forEach(function (button, index) {
          var isActive = panelNameForButton(button, index) === panelName;
          button.classList.toggle("tc-tab-active", isActive);
          button.setAttribute("aria-selected", isActive ? "true" : "false");
          button.setAttribute("tabindex", isActive ? "0" : "-1");
        });

        blocks.forEach(function (block) {
          var isCurrentPanel = panelNameForBlock(block) === panelName;
          block.hidden = !isCurrentPanel;
          block.setAttribute("aria-hidden", isCurrentPanel ? "false" : "true");
        });

        visibleBlocks().forEach(function (block) {
          var isOpen = block.classList.contains("tc-detail-open");
          var header = block.querySelector("header");
          var icon = block.querySelector("header span");
          if (header) header.setAttribute("aria-expanded", isOpen ? "true" : "false");
          if (icon) icon.textContent = isOpen ? "⊖" : "⊕";
        });
      }

      blocks.forEach(function (block, index) {
        if (!block.hasAttribute("data-tc-panel")) block.setAttribute("data-tc-panel", "details");
        var header = block.querySelector("header");
        if (!header) return;
        header.setAttribute("role", "button");
        header.setAttribute("tabindex", "0");
        header.setAttribute("aria-expanded", block.classList.contains("tc-detail-open") ? "true" : "false");
        header.addEventListener("click", function () {
          setBlockOpen(block, !block.classList.contains("tc-detail-open"));
        });
        header.addEventListener("keydown", function (event) {
          if (event.key !== "Enter" && event.key !== " ") return;
          event.preventDefault();
          setBlockOpen(block, !block.classList.contains("tc-detail-open"));
        });
      });

      tabButtons.forEach(function (button, index) {
        var panelName = panelNameForButton(button, index);
        button.setAttribute("role", button.getAttribute("role") || "tab");
        button.setAttribute("aria-selected", button.classList.contains("tc-tab-active") ? "true" : "false");
        button.addEventListener("click", function () {
          setActivePanel(panelName);
        });
        button.addEventListener("keydown", function (event) {
          if (event.key !== "ArrowRight" && event.key !== "ArrowLeft") return;
          event.preventDefault();
          var nextIndex = (index + (event.key === "ArrowRight" ? 1 : -1) + tabButtons.length) % tabButtons.length;
          tabButtons[nextIndex].focus();
          tabButtons[nextIndex].click();
        });
      });

      var activeButton = tabButtons.find(function (button) {
        return button.classList.contains("tc-tab-active");
      });
      setActivePanel(activeButton ? panelNameForButton(activeButton, tabButtons.indexOf(activeButton)) : panelNameForBlock(blocks[0]));
    });
  }

  function lazyLoadImages() {
    qsAll("main section:not(:first-of-type) img, footer img, .pg-footer img").forEach(function (image) {
      if (image.closest("[data-menu], [data-cart-overlay]")) return;
      if (!image.hasAttribute("loading")) image.setAttribute("loading", "lazy");
      if (!image.hasAttribute("decoding")) image.setAttribute("decoding", "async");
    });
  }

  function setupAnnouncementMarquees() {
    if (reducedMotionQuery.matches) return;

    var marqueeDuration = "120s";
    var tracks = new Set(qsAll(".pg-announcement-track"));

    qsAll("header > div:first-child > div").forEach(function (track) {
      var bar = track.parentElement;
      if (!bar || String(bar.className).indexOf("bg-[#ef6b29]") === -1) return;
      tracks.add(track);
    });

    tracks.forEach(function (track) {
      track.style.animationDuration = marqueeDuration;
      if (track.dataset.announcementMarquee === "ready") return;

      var labels = qsAll(":scope > *", track).map(function (child) {
        return child.textContent ? child.textContent.trim() : "";
      }).filter(Boolean);
      var uniqueLabels = Array.from(new Set(labels));

      if (!uniqueLabels.length) return;

      var bar = track.parentElement;
      if (bar) {
        bar.classList.add("announcement-marquee");
        bar.setAttribute("aria-label", uniqueLabels.join(", "));
      }

      track.textContent = "";
      track.dataset.announcementMarquee = "ready";
      track.setAttribute("aria-hidden", "true");
      track.classList.add("announcement-marquee-track");
      track.style.animationDuration = marqueeDuration;

      function buildGroup() {
        var group = document.createElement("span");
        group.className = "announcement-marquee-group";

        for (var index = 0; index < 8; index += 1) {
          uniqueLabels.forEach(function (label) {
            var item = document.createElement("span");
            item.className = "announcement-marquee-item";
            item.textContent = label;
            group.appendChild(item);
          });
        }

        return group;
      }

      track.appendChild(buildGroup());
      track.appendChild(buildGroup());
    });
  }

  function bindScrollAnimations() {
    if (reducedMotionQuery.matches || !("IntersectionObserver" in window)) return;
    var animated = qsAll([
      "main > section:not(:first-of-type)",
      ".site-footer",
      ".pg-footer",
      ".tutorial-card",
      ".tutorial-product-card",
      ".pg-product-type-card",
      ".pg-family-gallery img",
      ".pg-compare-card",
      ".shop-card",
      ".shop-product-card",
      ".tc-related-card",
      ".meta-product-card",
      ".meta-testimonial-card",
      ".about-care-item",
      ".product-card"
    ].join(",")).filter(function (node) {
      return !node.closest("header, [data-menu], [data-cart-overlay], .product-carousel");
    });
    if (!animated.length) return;

    animated.forEach(function (node, index) {
      node.setAttribute("data-animate", "");
      node.style.setProperty("--animate-delay", Math.min(index % 4, 3) * 55 + "ms");
    });
    document.documentElement.classList.add("motion-ready");

    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        entry.target.classList.add("is-visible");
        observer.unobserve(entry.target);
      });
    }, { rootMargin: "0px 0px -10% 0px", threshold: 0.08 });

    animated.forEach(function (node) {
      observer.observe(node);
    });
  }

  function linkInstagramCollages() {
    var selectors = [
      ".collage-card",
      ".mobile-collage-card",
      ".about-family-gallery-image",
      ".about-family-gallery-mobile-image",
      ".about-hero-image",
      ".about-hero-tablet-image",
      ".pg-family-grid img"
    ].join(",");

    qsAll(selectors).forEach(function (image) {
      if (image.closest("a")) return;
      var target = image.parentElement && image.parentElement.tagName === "PICTURE"
        ? image.parentElement
        : image;
      var link = document.createElement("a");
      link.className = "babiini-instagram-frame";
      link.href = INSTAGRAM_URL;
      link.target = "_blank";
      link.rel = "noopener noreferrer";
      link.setAttribute("aria-label", "Ver Babiini en Instagram");
      target.parentNode.insertBefore(link, target);
      link.appendChild(target);
    });

    qsAll('a[href="#instagram"]').forEach(function (link) {
      link.href = INSTAGRAM_URL;
      link.target = "_blank";
      link.rel = "noopener noreferrer";
    });
  }

  function initReviewContainers() {
    qsAll("[data-amazon-reviews]").forEach(function (section) {
      var cards = qsAll(".amazon-review-card", section);
      section.hidden = cards.length === 0;
    });
  }

  function preventNewsletterSubmit() {
    qsAll(".site-footer-form, .about-newsletter-form, .pg-newsletter-form").forEach(function (form) {
      form.addEventListener("submit", function (event) {
        event.preventDefault();
      });
    });
  }

  function assetUrl(name) {
    return "/cdn/shop/t/3/assets/" + name;
  }

  function patchCachedSystemRoutes() {
    if (document.querySelector(".pg-header, .site-footer, .pg-footer")) return;

    var path = window.location.pathname.replace(/\/$/, "") || "/";
    var shouldPatch =
      path === "/collections/all" ||
      path === "/cart" ||
      path === "/404" ||
      path.indexOf("/blogs/") === 0 ||
      document.querySelector(".collection-products, form[action='/cart']");

    if (!shouldPatch) return;

    document.body.classList.add("shop-page", "babiini-system-page", "babiini-client-patched");

    var header = document.createElement("header");
    header.className = "pg-header";
    header.innerHTML =
      '<div class="pg-announcement" aria-label="Beneficios de compra"><div class="pg-announcement-track">' +
      '<span style="left: 3.5rem">Envío gratuito en toda Europa</span>' +
      '<span style="left: 24.5625rem">Certificación de seguridad internacional</span>' +
      '<span style="left: 50.625rem">Envío gratuito en toda Europa</span>' +
      '<span style="left: 71.6875rem">Certificación de seguridad internacional</span>' +
      "</div></div>" +
      '<nav class="pg-nav shop-nav" aria-label="Principal">' +
      '<a class="pg-logo" href="/" aria-label="Babiini home"><img height="100" width="100" class="pg-logo-mark" src="' +
      assetUrl("babiini--products-general--logo-mark.svg") +
      '" alt="" /><img height="100" width="100" class="pg-logo-word" src="' +
      assetUrl("babiini--products-general--logo-word.svg") +
      '" alt="babiini" /></a>' +
      '<div class="pg-nav-links shop-nav-links"><a href="/">Portabebés ergonómicos</a><a href="/pages/comprar">Accesorios</a><a href="/pages/sobre-babiini">Sobre Babiini</a><a href="/pages/tutoriales">Tutoriales</a></div>' +
      '<div class="pg-nav-actions"><a class="pg-nav-buy" href="/pages/comprar">Comprar</a><a class="pg-nav-cart" href="/cart">Tu carrito<img height="100" width="100" src="' +
      assetUrl("babiini--nav-cart.svg") +
      '" alt="" /></a><button class="pg-menu-button" type="button" aria-label="Open menu" data-cache-menu-toggle><img height="100" width="100" class="shop-menu-icon-list" src="' +
      assetUrl("babiini--nav-menu-lines.svg") +
      '" alt="" /><img height="100" width="100" class="shop-menu-icon-close" src="' +
      assetUrl("babiini--mobile-menu-close.svg") +
      '" alt="" /></button></div></nav>' +
      '<div class="pg-mobile-menu" hidden data-cache-menu role="dialog" aria-modal="true" aria-label="Menú"><div class="pg-mobile-menu-header"><a class="pg-logo" href="/" aria-label="Babiini home"><img height="100" width="100" class="pg-logo-mark" src="' +
      assetUrl("babiini--products-general--logo-mark.svg") +
      '" alt="" /><img height="100" width="100" class="pg-logo-word" src="' +
      assetUrl("babiini--products-general--logo-word.svg") +
      '" alt="babiini" /></a><button class="pg-mobile-menu-close" type="button" aria-label="Close menu" data-cache-menu-close><img height="100" width="100" src="' +
      assetUrl("babiini--mobile-menu-close.svg") +
      '" alt="" /></button></div><div class="pg-mobile-menu-body"><nav class="pg-mobile-menu-links" aria-label="Mobile menu"><a href="/">Portabebés ergonómicos</a><a href="/pages/comprar">Accesorios</a><a href="/pages/sobre-babiini">Sobre Babiini</a><a href="/pages/tutoriales">Tutoriales</a></nav><div class="pg-mobile-menu-actions"><a class="pg-mobile-menu-buy" href="/pages/comprar">Comprar</a><a class="pg-mobile-menu-cart" href="/cart">Tu carrito</a></div></div></div>';

    var main = document.createElement("main");
    main.className = "shop-main babiini-system-main";

    var panel = document.createElement("section");
    panel.className = "babiini-system-panel";

    var contentNodes = qsAll("body > *").filter(function (node) {
      return node.tagName !== "SCRIPT" && node.tagName !== "STYLE";
    });

    contentNodes.forEach(function (node) {
      panel.appendChild(node);
    });

    main.appendChild(panel);

    var footer = document.createElement("footer");
    footer.className = "pg-footer";
    footer.innerHTML =
      '<div class="pg-footer-inner"><div class="pg-footer-main"><a class="pg-footer-logo" href="/" aria-label="Babiini home"><img height="100" width="100" class="pg-footer-logo-mark" src="' +
      assetUrl("babiini--products-general--footer-logo-mark.svg") +
      '" alt="" /><img height="100" width="100" class="pg-footer-logo-word" src="' +
      assetUrl("babiini--products-general--footer-logo-word.svg") +
      '" alt="babiini" /></a><p class="shop-mobile-footer-intro">Recibe las últimas novedades y consejos de crianza directamente en tu bandeja.</p><nav class="pg-footer-links" aria-label="Productos"><a href="/">Portabebés ergonómicos</a><a href="/pages/comprar">Comprar</a></nav><nav class="pg-footer-links" aria-label="Babiini"><a href="/pages/sobre-babiini">Sobre Babiini</a><a href="/pages/tutoriales">Tutoriales</a><a href="#contacto">Contacto</a><a href="/pages/faq">FAQ</a></nav><section class="pg-newsletter" aria-label="Newsletter"><h2>Suscribirse</h2><p>Recibe las últimas novedades y consejos de crianza directamente en tu bandeja.</p><form class="pg-newsletter-form"><label class="pg-sr-only" for="cache-footer-email">Tu correo electrónico</label><input id="cache-footer-email" type="email" placeholder="Tu correo electrónico" /><button type="submit"><span class="shop-footer-submit-desktop">Enviar</span><span class="shop-footer-submit-tablet">Suscribirme</span></button></form><p class="pg-consent">Al suscribirte aceptas nuestra política de privacidad y consentimiento de comunicaciones.</p></section></div><div class="pg-footer-bottom"><div class="pg-legal"><p><span class="shop-copy-desktop">© 2026 Babiini. Todos los derechos reservados.</span><span class="shop-copy-tablet">© 2026 Babiini. Todos los derechos reservados.</span><span class="shop-copy-mobile">© 2026 Babiini. Todos los derechos reservados.</span></p><a href="#privacidad"><span class="shop-copy-desktop-tablet">Política de privacidad</span><span class="shop-copy-mobile">Política de privacidad</span></a><a href="#terminos"><span class="shop-copy-desktop-tablet">Términos de servicio</span><span class="shop-copy-mobile">Términos de servicio</span></a><a href="#cookies"><span class="shop-copy-desktop-tablet">Configuración de cookies</span><span class="shop-copy-mobile">Configuración de cookies</span></a></div></div></div>';

    document.body.insertBefore(header, document.body.firstChild);
    var firstScript = document.body.querySelector("script");
    document.body.insertBefore(main, firstScript);
    document.body.insertBefore(footer, firstScript);

    var style = document.createElement("style");
    style.textContent =
      ".babiini-client-patched .collection-products{display:grid;grid-template-columns:repeat(auto-fit,minmax(16rem,1fr));gap:1.5rem;margin-top:2rem}.babiini-client-patched .collection-product{border:1px solid #d4d0cd;border-radius:.5rem;padding:1.5rem}.babiini-client-patched .babiini-system-panel>div[id^='shopify-section']>h1,.babiini-client-patched .babiini-system-panel h1{font-size:clamp(2.25rem,4vw,3rem);font-weight:500;line-height:1.2;margin:0 0 1rem}.babiini-client-patched .babiini-system-panel a{text-decoration:underline;text-underline-offset:.1875rem}";
    document.head.appendChild(style);

    var cacheMenu = header.querySelector("[data-cache-menu]");
    var openButton = header.querySelector("[data-cache-menu-toggle]");
    var closeButton = header.querySelector("[data-cache-menu-close]");
    function setCacheMenu(open) {
      if (!cacheMenu) return;
      cacheMenu.hidden = !open;
      document.body.classList.toggle("menu-open", open);
      if (openButton) {
        openButton.setAttribute("aria-expanded", open ? "true" : "false");
        openButton.setAttribute("aria-label", open ? "Close menu" : "Open menu");
      }
      document.body.style.overflow = open ? "hidden" : "";
    }
    function closeCacheMenu() {
      setCacheMenu(false);
    }
    if (openButton && cacheMenu) {
      openButton.addEventListener("click", function () {
        setCacheMenu(cacheMenu.hidden);
      });
    }
    if (closeButton) closeButton.addEventListener("click", closeCacheMenu);
    if (cacheMenu) {
      qsAll("a", cacheMenu).forEach(function (link) {
        link.addEventListener("click", closeCacheMenu);
      });
    }
  }

  function init() {
    patchCachedSystemRoutes();
    lazyLoadImages();
    setupAnnouncementMarquees();
    bindMenuAndCart();
    bindCartQuantities();
    bindProductCards();
    bindProductSliders();
    bindProductAccordions();
    bindScrollAnimations();
    linkInstagramCollages();
    initReviewContainers();
    preventNewsletterSubmit();
    getCart();

    var params = new URLSearchParams(window.location.search);
    if (params.get("cart") === "filled" || params.get("cart") === "empty") openCart();
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();

/* babiini-figma-2026-sync:start */
if (document.body.dataset.babiiniApproved !== "true") {
(() => {
const homeProductPositions = [
  "hp-card-tiny-left",
  "hp-card-small-left",
  "hp-card-main-left",
  "hp-card-main-right",
  "hp-card-small-right",
  "hp-card-tiny-right",
];

document.querySelectorAll("[data-hp-carousel]").forEach((carousel) => {
  const cards = Array.from(carousel.querySelectorAll(".hp-card"));
  let offset = 0;

  const render = () => {
    cards.forEach((card, index) => {
      const position = homeProductPositions[(index - offset + cards.length) % cards.length];
      const isPrimaryCard = position === "hp-card-main-left" || position === "hp-card-main-right";

      card.classList.remove(...homeProductPositions);
      card.classList.add(position);
      card.setAttribute("aria-hidden", String(!isPrimaryCard));
      card.querySelectorAll("a, button").forEach((control) => {
        control.tabIndex = isPrimaryCard ? 0 : -1;
      });
    });
  };

  carousel.querySelector("[data-hp-prev]")?.addEventListener("click", () => {
    offset = (offset - 1 + cards.length) % cards.length;
    render();
  });

  carousel.querySelector("[data-hp-next]")?.addEventListener("click", () => {
    offset = (offset + 1) % cards.length;
    render();
  });

  render();
});

document.querySelectorAll("[data-apv-carousel]").forEach((carousel) => {
  const grid = carousel.querySelector(".apv-grid");
  const viewport = carousel.querySelector(".apv-viewport");
  if (!grid || !viewport) return;

  let animating = false;
  let pointerStart = null;
  const reducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)");

  const stepSize = () => {
    const firstCard = grid.querySelector(".apv-card:not([data-apv-clone])");
    const gap = Number.parseFloat(getComputedStyle(grid).columnGap) || 0;
    return firstCard ? firstCard.getBoundingClientRect().width + gap : 0;
  };

  const finishAfterTransition = (callback) => {
    let finished = false;
    const finish = () => {
      if (finished) return;
      finished = true;
      grid.removeEventListener("transitionend", handleTransitionEnd);
      callback();
      animating = false;
    };
    const handleTransitionEnd = (event) => {
      if (event.target !== grid || event.propertyName !== "transform") return;
      finish();
    };

    grid.addEventListener("transitionend", handleTransitionEnd);
    window.setTimeout(finish, reducedMotion.matches ? 30 : 520);
  };

  const slideNext = () => {
    if (animating) return;
    const firstCard = grid.querySelector(".apv-card:not([data-apv-clone])");
    if (!firstCard) return;
    animating = true;

    const clone = firstCard.cloneNode(true);
    clone.dataset.apvClone = "true";
    clone.setAttribute("aria-hidden", "true");
    grid.append(clone);
    grid.style.transition = reducedMotion.matches ? "none" : "transform 420ms cubic-bezier(.22,.61,.36,1)";
    requestAnimationFrame(() => {
      grid.style.transform = `translate3d(-${stepSize()}px, 0, 0)`;
    });

    finishAfterTransition(() => {
      grid.style.transition = "none";
      clone.remove();
      grid.append(firstCard);
      grid.style.transform = "translate3d(0, 0, 0)";
    });
  };

  const slidePrev = () => {
    if (animating) return;
    const cards = grid.querySelectorAll(".apv-card:not([data-apv-clone])");
    const lastCard = cards[cards.length - 1];
    if (!lastCard) return;
    animating = true;

    const clone = lastCard.cloneNode(true);
    clone.dataset.apvClone = "true";
    clone.setAttribute("aria-hidden", "true");
    grid.prepend(clone);
    grid.style.transition = "none";
    grid.style.transform = `translate3d(-${stepSize()}px, 0, 0)`;
    grid.getBoundingClientRect();
    grid.style.transition = reducedMotion.matches ? "none" : "transform 420ms cubic-bezier(.22,.61,.36,1)";
    requestAnimationFrame(() => {
      grid.style.transform = "translate3d(0, 0, 0)";
    });

    finishAfterTransition(() => {
      grid.style.transition = "none";
      clone.remove();
      grid.prepend(lastCard);
      grid.style.transform = "translate3d(0, 0, 0)";
    });
  };

  carousel.querySelector("[data-apv-prev]")?.addEventListener("click", slidePrev);
  carousel.querySelector("[data-apv-next]")?.addEventListener("click", slideNext);

  viewport.addEventListener("pointerdown", (event) => {
    if (!event.isPrimary) return;
    pointerStart = event.clientX;
  });
  viewport.addEventListener("pointerup", (event) => {
    if (pointerStart === null) return;
    const distance = event.clientX - pointerStart;
    pointerStart = null;
    if (Math.abs(distance) < 40) return;
    if (distance < 0) slideNext();
    else slidePrev();
  });
  viewport.addEventListener("pointercancel", () => { pointerStart = null; });
});


document.querySelectorAll(".about-care-values").forEach((section) => {
  const container = section.querySelector(".about-care-container");
  const list = section.querySelector(".about-care-list");
  const items = Array.from(section.querySelectorAll(".about-care-item"));
  if (!container || !list || items.length < 2) return;

  const mobileCare = window.matchMedia("(max-width: 767px)");
  const dots = document.createElement("div");
  dots.className = "about-care-dots";
  dots.setAttribute("role", "tablist");
  dots.setAttribute("aria-label", "Lo que cuidamos");

  const dotButtons = items.map((item, index) => {
    const button = document.createElement("button");
    button.className = "about-care-dot";
    button.type = "button";
    button.setAttribute("role", "tab");
    button.setAttribute("aria-label", `Ver valor ${index + 1} de ${items.length}`);
    button.addEventListener("click", () => setActive(index));
    dots.append(button);
    return button;
  });

  container.append(dots);
  let activeIndex = 0;
  let pointerStart = null;

  const render = () => {
    const isMobile = mobileCare.matches;
    list.tabIndex = isMobile ? 0 : -1;
    dots.hidden = !isMobile;

    items.forEach((item, index) => {
      let offset = index - activeIndex;
      if (offset > 1) offset -= items.length;
      if (offset < -1) offset += items.length;
      const isActive = index === activeIndex;

      item.style.setProperty("--care-offset", String(offset));
      item.style.setProperty("--care-opacity", String(!isMobile || isActive ? 1 : 0));
      item.style.setProperty("--care-visibility", !isMobile || isActive ? "visible" : "hidden");
      if (isMobile) {
        item.setAttribute("aria-hidden", String(!isActive));
        item.inert = !isActive;
      } else {
        item.removeAttribute("aria-hidden");
        item.inert = false;
      }
    });

    dotButtons.forEach((button, index) => {
      const isActive = index === activeIndex;
      button.setAttribute("aria-current", String(isActive));
      button.setAttribute("aria-selected", String(isActive));
      button.tabIndex = isActive ? 0 : -1;
    });
  };

  const setActive = (index) => {
    activeIndex = (index + items.length) % items.length;
    render();
  };

  list.addEventListener("keydown", (event) => {
    if (!mobileCare.matches) return;
    if (event.key === "ArrowRight") {
      event.preventDefault();
      setActive(activeIndex + 1);
    }
    if (event.key === "ArrowLeft") {
      event.preventDefault();
      setActive(activeIndex - 1);
    }
  });

  list.addEventListener("pointerdown", (event) => {
    if (!mobileCare.matches || !event.isPrimary) return;
    pointerStart = event.clientX;
  });
  list.addEventListener("pointerup", (event) => {
    if (pointerStart === null) return;
    const distance = event.clientX - pointerStart;
    pointerStart = null;
    if (Math.abs(distance) < 35) return;
    setActive(activeIndex + (distance < 0 ? 1 : -1));
  });
  list.addEventListener("pointercancel", () => { pointerStart = null; });
  mobileCare.addEventListener("change", render);
  render();
});


const setupMobilePagedSlider = ({ root, items, dotsClass, dotClass, label }) => {
  if (!root || items.length < 2) return;
  const mobileSlider = window.matchMedia("(max-width: 767px)");
  const dots = document.createElement("div");
  dots.className = dotsClass;
  dots.setAttribute("role", "tablist");
  dots.setAttribute("aria-label", label);

  let activeIndex = 0;
  let pointerStart = null;
  const dotButtons = items.map((item, index) => {
    const button = document.createElement("button");
    button.className = dotClass;
    button.type = "button";
    button.setAttribute("role", "tab");
    button.setAttribute("aria-label", `Ver opción ${index + 1} de ${items.length}`);
    button.addEventListener("click", () => setActive(index));
    dots.append(button);
    return button;
  });
  root.append(dots);

  const render = () => {
    const isMobile = mobileSlider.matches;
    dots.hidden = !isMobile;
    root.tabIndex = isMobile ? 0 : -1;
    items.forEach((item, index) => {
      let offset = index - activeIndex;
      if (offset > 1) offset -= items.length;
      if (offset < -1) offset += items.length;
      const isActive = index === activeIndex;
      item.style.setProperty("--pg-slide-offset", String(offset));
      item.style.setProperty("--pg-slide-translate", `${offset * 100}%`);
      item.style.setProperty("--pg-slide-translate-wide", `${offset * 130}%`);
      item.style.setProperty("--pg-slide-transform-wide", `${-50 + (offset * 130)}%`);
      if (isMobile) {
        item.setAttribute("aria-hidden", String(!isActive));
        item.inert = !isActive;
      } else {
        item.removeAttribute("aria-hidden");
        item.inert = false;
      }
    });
    dotButtons.forEach((button, index) => {
      const isActive = index === activeIndex;
      button.setAttribute("aria-current", String(isActive));
      button.setAttribute("aria-selected", String(isActive));
      button.tabIndex = isActive ? 0 : -1;
    });
  };

  const setActive = (index) => {
    activeIndex = (index + items.length) % items.length;
    render();
  };

  root.addEventListener("keydown", (event) => {
    if (!mobileSlider.matches) return;
    if (event.key === "ArrowRight") {
      event.preventDefault();
      setActive(activeIndex + 1);
    }
    if (event.key === "ArrowLeft") {
      event.preventDefault();
      setActive(activeIndex - 1);
    }
  });
  root.addEventListener("pointerdown", (event) => {
    if (!mobileSlider.matches || !event.isPrimary) return;
    pointerStart = event.clientX;
  });
  root.addEventListener("pointerup", (event) => {
    if (pointerStart === null) return;
    const distance = event.clientX - pointerStart;
    pointerStart = null;
    if (Math.abs(distance) < 35) return;
    setActive(activeIndex + (distance < 0 ? 1 : -1));
  });
  root.addEventListener("pointercancel", () => { pointerStart = null; });
  mobileSlider.addEventListener("change", render);
  render();
};

const mobilePromos = document.querySelector(".pg-mobile-promos");
setupMobilePagedSlider({
  root: mobilePromos,
  items: mobilePromos ? Array.from(mobilePromos.querySelectorAll(".pg-mobile-promo-card")) : [],
  dotsClass: "pg-mobile-slide-dots",
  dotClass: "pg-mobile-slide-dot",
  label: "Promociones Babiini",
});

const productTypeSlider = document.querySelector(".pg-product-card-stack");
setupMobilePagedSlider({
  root: productTypeSlider,
  items: productTypeSlider ? Array.from(productTypeSlider.querySelectorAll(".pg-product-type-card")) : [],
  dotsClass: "pg-product-slide-dots",
  dotClass: "pg-product-slide-dot",
  label: "Tipos de portabebés",
});

const setupHomeTestimonials = () => {
  const section = document.querySelector(".testimonials-section");
  const track = section?.querySelector(".testimonials-content");
  const controls = section?.querySelectorAll(".testimonial-arrow");
  if (!section || !track || !controls || controls.length < 2) return;

  const cards = Array.from(track.querySelectorAll(":scope > .testimonial-card"));
  if (cards.length < 2) return;

  const mobile = window.matchMedia("(max-width: 767px)");
  const tablet = window.matchMedia("(min-width: 768px) and (max-width: 991px)");
  const status = document.createElement("p");
  status.className = "sr-only testimonial-carousel-status";
  status.setAttribute("aria-live", "polite");
  status.setAttribute("aria-atomic", "true");
  section.append(status);

  section.setAttribute("role", "region");
  section.setAttribute("aria-roledescription", "carousel");
  section.setAttribute("aria-label", "Historias Babiini");
  track.id = track.id || "home-testimonials-track";

  cards.forEach((card, index) => {
    card.setAttribute("role", "group");
    card.setAttribute("aria-roledescription", "testimonio");
    card.setAttribute("aria-label", `${index + 1} de ${cards.length}`);
  });

  const previous = controls[0];
  const next = controls[1];
  previous.setAttribute("aria-label", "Testimonio anterior");
  next.setAttribute("aria-label", "Siguiente testimonio");
  previous.setAttribute("aria-controls", track.id);
  next.setAttribute("aria-controls", track.id);

  const visibleCount = () => (mobile.matches ? 1 : tablet.matches ? 2 : cards.length);
  const currentCards = () => Array.from(track.querySelectorAll(":scope > .testimonial-card"));

  const render = ({ announce = false } = {}) => {
    const visible = visibleCount();
    const orderedCards = currentCards();
    orderedCards.forEach((card, index) => {
      const isVisible = index < visible;
      card.hidden = !isVisible;
      card.setAttribute("aria-hidden", String(!isVisible));
      card.inert = !isVisible;
    });

    section.dataset.testimonialVisibleCount = String(visible);
    section.classList.add("is-testimonial-carousel-ready");

    if (announce) {
      const titles = orderedCards
        .slice(0, visible)
        .map((card) => card.querySelector(".testimonial-title")?.textContent?.trim())
        .filter(Boolean);
      status.textContent = visible === 1
        ? `Mostrando: ${titles[0] || "testimonio"}`
        : `Mostrando ${visible} testimonios: ${titles.join(", ")}`;
    }
  };

  const move = (direction) => {
    const orderedCards = currentCards();
    if (direction > 0) track.append(orderedCards[0]);
    else track.prepend(orderedCards[orderedCards.length - 1]);
    render({ announce: true });
  };

  previous.addEventListener("click", () => move(-1));
  next.addEventListener("click", () => move(1));

  section.addEventListener("keydown", (event) => {
    if (event.key === "ArrowLeft") {
      event.preventDefault();
      move(-1);
    }
    if (event.key === "ArrowRight") {
      event.preventDefault();
      move(1);
    }
  });

  let pointerStart = null;
  track.addEventListener("pointerdown", (event) => {
    if (!mobile.matches || !event.isPrimary) return;
    pointerStart = event.clientX;
  });
  track.addEventListener("pointerup", (event) => {
    if (pointerStart === null) return;
    const distance = event.clientX - pointerStart;
    pointerStart = null;
    if (Math.abs(distance) < 35) return;
    move(distance < 0 ? 1 : -1);
  });
  track.addEventListener("pointercancel", () => { pointerStart = null; });

  mobile.addEventListener("change", () => render());
  tablet.addEventListener("change", () => render());
  render();
};

setupHomeTestimonials();


const metaTrustSlider = document.querySelector(".meta-trust-inner");
setupMobilePagedSlider({
  root: metaTrustSlider,
  items: metaTrustSlider ? Array.from(metaTrustSlider.querySelectorAll(":scope > article")) : [],
  dotsClass: "meta-slider-dots",
  dotClass: "meta-slider-dot",
  label: "Beneficios Babiini",
});

const metaDuoSlider = document.querySelector(".meta-duo-cards");
setupMobilePagedSlider({
  root: metaDuoSlider,
  items: metaDuoSlider ? Array.from(metaDuoSlider.querySelectorAll(":scope > .meta-duo-card")) : [],
  dotsClass: "meta-slider-dots",
  dotClass: "meta-slider-dot",
  label: "Formas de porteo Babiini",
});

const metaTestimonialSlider = document.querySelector(".meta-testimonial-row");
setupMobilePagedSlider({
  root: metaTestimonialSlider,
  items: metaTestimonialSlider ? Array.from(metaTestimonialSlider.querySelectorAll(":scope > article")) : [],
  dotsClass: "meta-slider-dots",
  dotClass: "meta-slider-dot",
  label: "Historias Babiini",
});


})();

(() => {
const reviewModal = document.querySelector("[data-review-modal]");
const reviewOpen = document.querySelector("[data-review-open]");
const reviewCloseButtons = document.querySelectorAll("[data-review-close]");
const reviewFilterButtons = document.querySelectorAll("[data-review-filter]");
const reviewItems = document.querySelectorAll("[data-review-product]");
const starButtons = document.querySelectorAll(".review-star-input button");

function setModal(open) {
  if (!reviewModal) return;
  reviewModal.hidden = !open;
  document.body.style.overflow = open ? "hidden" : "";
}

reviewOpen?.addEventListener("click", () => setModal(true));
reviewCloseButtons.forEach((button) => button.addEventListener("click", () => setModal(false)));
reviewModal?.addEventListener("mousedown", (event) => {
  if (event.target === reviewModal) setModal(false);
});

reviewFilterButtons.forEach((button) => {
  button.addEventListener("click", () => {
    const filter = button.dataset.reviewFilter;
    reviewFilterButtons.forEach((item) => item.classList.toggle("is-active", item === button));
    reviewItems.forEach((item) => {
      item.hidden = item.dataset.reviewProduct !== filter;
    });
  });
});

starButtons.forEach((button, index) => {
  button.addEventListener("click", () => {
    starButtons.forEach((item, itemIndex) => item.classList.toggle("is-active", itemIndex <= index));
  });
});

document.querySelector("[data-review-submit]")?.addEventListener("click", () => setModal(false));

document.querySelectorAll(".reviews-product-group").forEach((group) => {
  const grid = group.querySelector("[data-review-products]");
  if (!grid) return;
  const rotate = (direction) => {
    if (direction > 0) grid.append(grid.firstElementChild);
    else grid.prepend(grid.lastElementChild);
  };
  group.querySelector("[data-review-products-prev]")?.addEventListener("click", () => rotate(-1));
  group.querySelector("[data-review-products-next]")?.addEventListener("click", () => rotate(1));
});

document.addEventListener("keydown", (event) => {
  if (event.key === "Escape") setModal(false);
});

})();
}
/* babiini-figma-2026-sync:end */
